import ReactDOM from 'react-dom'

const PortalStandard = (props) => {
    return ReactDOM.createPortal(props.children, document.getElementById('portal-root'))
}

export default PortalStandard
